import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="page-not-found" className="flex min-h-[70vh] flex-col items-center justify-center gap-6 px-4 pt-[72px] text-center">
      <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-emerald-700">
        404 · Page Not Found
      </p>
      <h1 className="font-display text-4xl font-bold tracking-tight text-ink sm:text-5xl">
        This container sailed without us.
      </h1>
      <p className="max-w-md text-base text-slate-600">
        The page you're looking for doesn't exist — but the catalog does.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="rounded-full bg-forest px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-forest-hover"
      >
        Back to Home
      </Link>
    </div>
  );
}
